import axios from '../Backend';

export const updateSettings=async(settings)=>{
    try{
            await axios.post('/companySettings/updateSettings', settings);

        }catch(e){
            console.log('dispatch updateSettings fail')
            console.log(JSON.stringify(e))
        }

}

export const updateSpecificSetting = async (settings)=>{
    await axios.patch('/companySettings', settings);
}